import { RiGhost2Fill } from 'react-icons/ri'
import './empty.css'

const Empty = ({text}) => {
      return (
            <div className="empty_content">
                  <div className="ghost_icon">
                        <RiGhost2Fill/>
                  </div>
                  <h2>{text}</h2>
            </div>
      )
}

export default Empty
